import { hydrate } from 'preact-iso';
import { App } from './app';
import { LocaleProvider, detectLocale, type MessageCatalog } from './i18n';
import { ToastProvider } from './primitives/admin';
import manifest from '../../../../resources/i18n/manifest.json';
import enCatalog from '../../../../resources/i18n/en.json';
import './styles/tailwind.css';

interface RootAppProps {
    catalogs: Record<string, MessageCatalog>;
}

function RootApp({ catalogs }: RootAppProps) {
    return (
        <LocaleProvider manifest={manifest} catalogs={catalogs}>
            <ToastProvider>
                <App />
            </ToastProvider>
        </LocaleProvider>
    );
}

// The EN catalog ships inline (it's the platform fallback - always needed).
// Every other locale is fetched on demand for the locale the URL resolves
// to, so a visitor never downloads the other five catalogs' JSON.
async function main(): Promise<void> {
    if (typeof window === 'undefined') return;
    const root = document.getElementById('app');
    if (!root) return;

    const locale = detectLocale(window.location.pathname, manifest);
    const catalogs: Record<string, MessageCatalog> = {
        [manifest.defaultLocale]: enCatalog as unknown as MessageCatalog,
    };
    if (locale !== manifest.defaultLocale) {
        const mod = (await import(`../../../../resources/i18n/${locale}.json`)) as {
            default: MessageCatalog;
        };
        catalogs[locale] = mod.default;
    }

    hydrate(<RootApp catalogs={catalogs} />, root);
}

void main();
